import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  addTabAction,
  changeTabAction,
  deleteTabAction,
  setCurrentTabItemAction,
  setMenuFromApi,
} from '../redux/states/central'
import {TabCentralModel} from '../models'
export const useCentral = () => {
  const centralState = useSelector((store: AppStore) => store.central)
  const {tabs, currentTab} = centralState
  const currentTabItem = tabs[currentTab] || null
  const dispatch = useDispatch()

  const changeTab = (index: number) => {
    dispatch(changeTabAction(index))
  }

  const changeCurrentTabItem = (tab: TabCentralModel) => {
    dispatch(setCurrentTabItemAction(tab))
  }

  const addTab = (newTab: TabCentralModel) => {
    dispatch(addTabAction(newTab))
    return centralState.tabs.length
  }

  const deleteTab = (index: number) => {
    const updatedTabs = [...tabs]
    updatedTabs.splice(index, 1)
    dispatch(deleteTabAction(updatedTabs))
  }
  const setMenu = (menu: any[]) => {
    dispatch(setMenuFromApi(menu))
  }
  const isAllowed = (action: string) => {
    return currentTabItem.opciones?.some((item) => item.opcion === action)
  }

  return {
    panel: centralState.showPanel,
    currentTabItem,
    tabs: centralState.tabs,
    currentTab: centralState.currentTab,
    menu: centralState.menu,
    addTab,
    deleteTab,
    changeTab,
    changeCurrentTabItem,
    setMenu,
    isAllowed,
  }
}
